export default {
      id: "management-usage",
      viewBox: "25.3 31.05 49.4 37.9",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#management",
      toString: function () {
        return this.url;
      }
    }